import {gql} from '@apollo/client';

export const GET_PICKUP_TASK_DETAIL_ITEMS = gql`
  query GetPickupTaskDetailItemList($taskId: String!) {
    getPickupTaskDetailItemList(taskId: $taskId) {
      id
      pickupTaskId
      pickupAppointmentId
      appointmentNumber
      sequence
      site
      zipcode
      address
      quantity
      unit
      expectedPickupTime
      expectedArrivalTime
      actualQuantity
      actualUnit
      actualTime
      distance
      duration
      status
      type
      isUnloading
      hubName
      hubZipcode
      createdAt
      photosS3Keys
      photosUrls
      actualPickupTime
      cooperationWarehouseId
    }
  }
`;

export interface PickupTaskDetailItem {
    id: number | null;                // 预约单为pickup_task_appointment.id，卸货记录为pickup_task_unloading.id
    pickupTaskId: number;            // 任务ID
    pickupAppointmentId: number;     // 预约单ID
    appointmentNumber?: string;      // 预约单号（仅预约单有值）
    sequence?: number;               // 序号
    site?: string;                  // 站点名称
    zipcode?: string;               // 邮编
    address?: string;               // 地址
    quantity?: number;              // 数量
    unit?: string;                  // 单位
    expectedPickupTime?: string;   // 期望揽收时间
    expectedArrivalTime?: string;  //期望到达时间
    actualQuantity?: number;        // 实际数量
    actualUnit?: string;            // 实际单位
    actualTime?: string;            // 实际时间
    distance?: string;              // 距离
    duration?: string;              // 时长
    status: string;                 // 状态
    type: string;                   // 类型：APPOINTMENT 或 UNLOADING
    isUnloading: boolean;           // 是否为卸货记录
    hubName?: string;               // 卸货hub名称
    hubZipcode?: string;            // 卸货hub邮编
    createdAt?: string;             // 创建时间
    photosS3Keys?: string[];        // 卸货照片S3密钥列表（仅卸货记录有值）
    photosUrls?: string[];          // 卸货照片URL列表（仅卸货记录有值）
    actualPickupTime?: string;     //实际揽收时间
    cooperationWarehouseId?: number; //揽收站点ID
}

export interface GetPickupTaskDetailItemListResponse {
    getPickupTaskDetailItemList: PickupTaskDetailItem[];
}
